module.exports = __webpack_public_path__ + "img/54.10.pH.2597e57d.png";